import React, { useState } from "react";
import url from "../config/Config";

const stripHtmlTags = (str) => str.replace(/<[^>]*>/g, "");

function recortarHtmlPorPalabras(htmlString, maxPalabras) {
    // const textoPlano = stripHtmlTags(htmlString);
    const palabras = htmlString.trim().split(/\s+/);

    if (palabras.length <= maxPalabras) {
        return htmlString;
    }
    const palabrasCortadas = palabras.slice(0, maxPalabras).join(" ");
    return `${palabrasCortadas}...`;
}

const DescripcionDetalle = ({ htmlTexto }) => {

   
    const [maxPalabras, setMaxPalabras] = useState(100);
    if( !htmlTexto ) return null;  
    const textoVisible = recortarHtmlPorPalabras(htmlTexto, maxPalabras);

    const totalPalabras = htmlTexto.trim().split(/\s+/).length;
  
    return (
        <div>
            <div dangerouslySetInnerHTML={{ __html: textoVisible }} />

            {maxPalabras < totalPalabras && (
                <div className="w-full flex justify-center">
                    <span
                        onClick={() =>
                            setMaxPalabras((prev) => (prev < 400 ? 400 : 10000))
                        }
                        className="py-1 px-3 inline-block mx-auto cursor-pointer text-md font-semibold text-white items-center justify-center rounded-md bg-tertiary-personalize"
                    >
                        <i className="fas fa-plus cursor-pointer"></i> Ver más
                    </span>
                </div>
            )}
        </div>
    );
};

export default DescripcionDetalle;
